import { VehicleIcons, VehicleIconsValues, VehicleSkins, VehicleSkinsValues } from './CharacterSpine';

export const CharacterName = {
  Tom: 'tom',
  Jerry: 'jerry',
  Spike: 'spike',
  Toots: 'toots'
} as const;
export type CharacterNameKeys = keyof typeof CharacterName;
export type CharacterNameValues = typeof CharacterName[CharacterNameKeys];

export const Characters = [CharacterName.Tom, CharacterName.Jerry, CharacterName.Spike, CharacterName.Toots];

export const CharacterTaxiCard = {
  Tom: 'taxi-card-tom.png',
  Jerry: 'taxi-card-jerry.png',
  Spike: 'taxi-card-spike.png',
  Toots: 'taxi-card-toots.png'
} as const;
export type CharacterTaxiCardKeys = keyof typeof CharacterTaxiCard;
export type CharacterTaxiCardValues = typeof CharacterTaxiCard[CharacterTaxiCardKeys];

export const CharacterProfileTaxi = {
  Tom: 'char-tom.png',
  Jerry: 'char-jerry.png',
  Spike: 'char-spike.png',
  Toots: 'char-toots.png'
} as const;
export type CharacterProfileTaxiKeys = keyof typeof CharacterProfileTaxi;
export type CharacterProfileTaxiValues = typeof CharacterProfileTaxi[CharacterProfileTaxiKeys];

export const CharacterUpgrades = {
  TopSpeed: 'topSpeed',
  Acceleration: 'acceleration'
};
export type CharacterUpgradesKeys = keyof typeof CharacterUpgrades;
export type CharacterUpgradesValues = typeof CharacterUpgrades[CharacterUpgradesKeys];

export interface CharacterData {
  topSpeedUpgrades: number;
  accelerationUpgrades: number;
}

export class Character {
  public static maxTopSpeedUpgrades: number = 5;
  public static maxAccelerationUpgrades: number = 5;

  public static topSpeedUpgradeCosts: number[] = [10, 20, 30, 40, 50];
  public static accelerationUpgradeCosts: number[] = [10, 20, 30, 40, 50];

  public static topSpeedValue: number = 0.05;
  public static accelerationValue: number = 0.00025;

  public static upgradePool: CharacterUpgradesValues[] = this.buildUpgradePool();

  public static cardLookup: Record<CharacterNameValues, CharacterTaxiCardValues> = {
    [CharacterName.Tom]: CharacterTaxiCard.Tom,
    [CharacterName.Jerry]: CharacterTaxiCard.Jerry,
    [CharacterName.Spike]: CharacterTaxiCard.Spike,
    [CharacterName.Toots]: CharacterTaxiCard.Toots
  };

  public static taxiProfileLookup: Record<CharacterNameValues, CharacterProfileTaxiValues> = {
    [CharacterName.Tom]: CharacterProfileTaxi.Tom,
    [CharacterName.Jerry]: CharacterProfileTaxi.Jerry,
    [CharacterName.Spike]: CharacterProfileTaxi.Spike,
    [CharacterName.Toots]: CharacterProfileTaxi.Toots
  };

  public static taxiSkinLookup: Record<CharacterNameValues, VehicleSkinsValues> = {
    [CharacterName.Tom]: VehicleSkins.TaxiTom,
    [CharacterName.Jerry]: VehicleSkins.TaxiJerry,
    [CharacterName.Spike]: VehicleSkins.TaxiSpike,
    [CharacterName.Toots]: VehicleSkins.TaxiToots
  };

  public static skinToCharacterLookup: Partial<Record<VehicleSkinsValues, CharacterNameValues>> = {
    [VehicleSkins.TaxiTom]: CharacterName.Tom,
    [VehicleSkins.TaxiJerry]: CharacterName.Jerry,
    [VehicleSkins.TaxiSpike]: CharacterName.Spike,
    [VehicleSkins.TaxiToots]: CharacterName.Toots
  };

  public static skinToCharacterIconLookup: Record<VehicleSkinsValues, VehicleIconsValues> = {
    [VehicleSkins.TaxiTom]: VehicleIcons.Tom,
    [VehicleSkins.TaxiJerry]: VehicleIcons.Jerry,
    [VehicleSkins.TaxiSpike]: VehicleIcons.Spike,
    [VehicleSkins.TaxiToots]: VehicleIcons.Toots,

    // We need to fill all possible values, but these should never be used.
    [VehicleSkins.Default]: VehicleIcons.Tom,
    [VehicleSkins.TaxiNeutral]: VehicleIcons.Tom,
    [VehicleSkins.CarGreen]: VehicleIcons.Tom,
    [VehicleSkins.CarPurple]: VehicleIcons.Tom,
    [VehicleSkins.CarRed]: VehicleIcons.Tom
  };

  public static buildUpgradePool(): CharacterUpgradesValues[] {
    let pool: CharacterUpgradesValues[] = [];

    for (let i = 0; i < this.maxTopSpeedUpgrades; i++) pool.push(CharacterUpgrades.TopSpeed);
    for (let i = 0; i < this.maxAccelerationUpgrades; i++) pool.push(CharacterUpgrades.Acceleration);

    return pool;
  }
}
